<!-- divider -->
<div class="flex items-center justify-center mt-4 sm:mt-6 short:mt-3 border-b-[1px]">
</div>

<p class="text-center text-xs text-gray-500 mt-4 sm:mt-6 short:mt-3 px-2">{{ 'VERSION' | translate:{ version: version } }}</p>